import styled from "styled-components";

export const florenzBreadCrumb = styled.div`
  align-items: center;
  display: flex;
  .step {
    width: 209px;
    height: 34px;
    justify-content: center;
    display: flex;
    align-items: center;
    margin-right: -10px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
    font-family: "Nunito Sans";
    color: #1F1F52;
    &__disabled {
      color: #3E3E5B;
      cursor: default;
    }
    &__selected {
      font-family: "Nunito Sans Bold";
    }
    &__title {
      font-size: 13px;
      z-index: 200;
    }
    &__svg {
      z-index: 100;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  
`